var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Problems-ocean.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-5e3df664!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Problems-ocean.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Problems-ocean.vue
// module id = 148
// module chunks = 1